import { Typography } from '@recruit-robin/robin-theme/web-components';
import { memo } from 'react';

import type { FormatPattern } from './parse-formatted-text';

import { sanitizeEmailHtml } from '@/utils/sanitizeEmailHtml';
import { useStyles } from './HighlightText.styles';
import { parseFormattedText, toHTMLSegment } from './parse-formatted-text';

const DEFAULT_PATTERNS: FormatPattern[] = [{ pattern: /\*\*(.+?)\*\*/g, type: 'highlight' as const }];

export const HightlightText = memo(
  ({ text }: { text: string }) => {
    const classes = useStyles();
    const segments = parseFormattedText(sanitizeEmailHtml(text), DEFAULT_PATTERNS);

    return (
      <Typography variant={(v) => v.body.short} color={(c) => c.neutral.variant[80]} inline>
        {segments.map((segment, index) => toHTMLSegment(segment, index, classes['segment-type']))}
      </Typography>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.text === nextProps.text;
  },
);
